module.exports = __webpack_public_path__ + "img/persjanow.072f9d1c.jpg";